/**
 * liensDocuments.js
 */

import './liensDocuments.scss';
import $ from 'jquery';

$(document).ready(function() {
    $("#main-content a[href$='.pdf']").each(function(){
        $(this).attr("target", "_blank");
        $(this).attr("rel", "noopener noreferrer");
        $(this).addClass("fichierPdf");
    });
    
    /** Fonction pour ajouter la classe Fichier PDF à tous les lien  de la page formulaire sauf pour les adresses courriels **/
    $('.post-246 a').each(function() {
        $(this).not('[href^="mailto:"]').addClass('fichierPdf');
    });

    /** Fonction pour remplacer la chaine de carratères : Cliquez ici par une image ->  */
    $('.content-center a:contains("Cliquez ici")').each(function() {
        $(this).html('<img class="cliquezIci"  src="/wp-content/themes/401372-service-des-ressources-humaines-vradho/assets/images/fleche-cliquez-ici.svg"/>');
    });

});